import * as React from 'react'
import { CircularProgress } from '@mui/material';

interface Props {
    children?: React.ReactNode;
    showLoadingWhileThisIsTrue: boolean
}

interface State {

}

/**
 * used to wait some condition. If condition is false show loading icon
 * if condition is true, show children
 * WARNING: This only works for blocking UI.
 * Ex: User cannot click in some button if some api call it's not complete and a variable is currently null.
 * But, if you use the variable inside WaitingFor's children you will get null value.
 * This don't stop the execution of React.
 *
 * This don't work, because var1 is still null:
 * <WaitingFor showLoadingWhileThisIsTrue={this.state.var1===null}>
 *  <div>{this.state.var1.map( () => {})}</div>
 * </WaitingFor>
 */
export default class WaitingFor extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
    }

    render() {

        if (this.props.showLoadingWhileThisIsTrue) {
            return (
                <CircularProgress size={30} thickness={5} />
            )
        } else {
            return (<> {this.props.children} </>)
        }
    }
}
